import React from 'react';
import { Avatar, Form, Select, theme, Typography } from 'antd';
import { t } from '../../../../utils';

type SelectOption = {
	label?: string | React.ReactNode;
	value?: string;
	optionColor?: string;
};

interface Props {
	title: string;
	description: string;
	onChange: (e: string) => void;
	options: SelectOption[];
	value: string;
}

const { Text } = Typography;

export const DropdownSection = ({
	title,
	description,
	onChange,
	options,
	value,
}: Props) => {
	// eslint-disable-next-line @typescript-eslint/no-shadow
	const mappedOptions = options.map(({ label, optionColor, value }) => {
		return {
			label: getOption(label, optionColor),
			value,
			optionColor,
		};
	});
	const { token } = theme.useToken();

	return (
		<Form layout="vertical">
			<Form.Item
				label={<Text strong>{title}</Text>}
				required
				help={
					<Text type="secondary" style={{ fontSize: token.fontSizeSM }}>
						{description}
					</Text>
				}
				style={{ wordBreak: 'break-all' }}
			>
				<Select
					id="dropdown-select-id"
					onChange={onChange}
					options={mappedOptions}
					defaultValue={mappedOptions[0].value}
					value={value}
					aria-label={t('leftNav.signerFilled.role')}
				/>
			</Form.Item>
		</Form>
	);
};

const getOption = (label: React.ReactNode, optionColor: string) => {
	return (
		<>
			{optionColor && (
				<Avatar
					size={16}
					style={{
						background: optionColor,
						marginRight: '10px',
					}}
				/>
			)}
			{label}
		</>
	);
};
